import { useLocation, useNavigate, useParams } from "react-router-dom";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { toast } from "react-toastify";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { useEffect, useState } from "react";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import DocumentIcon from "../../../components/Icons/DocumentIcon";
import ViewDocumentModal from "../../Sites/ViewDocumentModal";
import {
  checkUserAccess,
  handleStatus,
  UserTypeHandler,
} from "../../../utility/CommonFunctions";
import moment from "moment";
import { useSelector } from "react-redux";
import ConfirmModal from "../../../components/comman/ConfirmModal";
import Logs from "../../Logs/Logs";

export default function LeaveDetail() {
  let { id } = useParams();
  const location = useLocation();
  const userDetails = useSelector((state) => state.root.userDetails);
  const navigate = useNavigate();
  const [leaveDetail, setLeaveDetail] = useState({});
  const [refreshLogs, setRefreshLogs] = useState(false);
  const [modal, setModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [rejectLeaveModal, setRejectLeaveModal] = useState(false);
  const toggleModal = () => {
    setModal(!modal);
  };
  const toggleReject = () => {
    setRejectLeaveModal(!rejectLeaveModal);
  };
  const [selectedDocument, setSelectedDocument] = useState(null);

  useEffect(() => {
    GetLeaveDetail();
  }, []);

  const GetLeaveDetail = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl?.get_Leave_detail + `?leaveId=${id}`;
    setDataLoading(true);
    callApi(API, options).then((response) => {
      setDataLoading(false);
      if (response?.status === true) {
        setLeaveDetail(response?.data);
      } else {
        toast.error(response?.message);
      }
    });
  };

  const handleDocumentClick = (item) => {
    const docUrl = {
      url: item?.url,
    };
    setSelectedDocument(docUrl);
    setModal(true);
  };

  const uniqueSiteTypes = [
    ...new Set(
      leaveDetail?.user?.usersites
        ?.map((item) => item.site.type)
        .filter(Boolean)
    ),
  ];

  const HandleApprove_Reject = (type, rejectReason) => {
    let newStatus;
    if (type == "approve") {
      newStatus = 1;
    } else if (type == "reject") {
      newStatus = 2;
    }
    const submitData = {
      type: "leave",
      id: leaveDetail?.id,
      status: newStatus,
      ...(type === "reject" && { rejectReason: rejectReason }),
    };
    setIsLoading(true);
    const options = {
      method: "POST",
      data: submitData,
    };
    let API = apiUrl?.user_status_update;
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        GetLeaveDetail();
        setRefreshLogs(true);
      } else {
        toast.error(response?.message);
      }
    });
  };

  const HandleDelete = (data) => {
    HandleApprove_Reject("reject", data);
    toggleReject();
  };

  return (
    <>
      <>
        <div className="content container-fluid">
          <div className="content-head mb-5 d-flex align-items-start justify-content-between">
            <div className="d-flex align-items-center justify-content-start gap-4">
              <button className="btn back-arrow" onClick={() => navigate(-1)}>
                <BackArrowIcon />
              </button>
              <h1 className="mb-0">Leave Detail</h1>
            </div>
          </div>
          <div className="card manage-user-list">
            <div className="card-body">
              <ul
                className={
                  dataLoading
                    ? "row list-unstyled mt-4 loading-skeleton"
                    : "row list-unstyled mt-4"
                }
              >
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      Emp. Name :-
                    </span>
                    {leaveDetail?.user?.name || "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      Emp. Code :-
                    </span>
                    {leaveDetail?.user?.employeeCode || "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">Status :-</span>
                    {handleStatus(leaveDetail?.status) || "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      Emp. Dept. :-
                    </span>
                    {leaveDetail?.user?.department?.name || "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      Emp. Designation :-
                    </span>
                    {leaveDetail?.user?.designation?.name || "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      {leaveDetail?.user?.type == 1 && " Office :-"}
                      {leaveDetail?.user?.type == 0 && " Site :-"}
                    </span>
                    {leaveDetail?.user?.type == 1
                      ? leaveDetail?.user?.site?.name
                      : leaveDetail?.user?.type == 0
                        ? leaveDetail?.user?.usersites?.[0]?.site?.name
                        : "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      Applied On :-
                    </span>
                    {(leaveDetail?.createdAt &&
                      moment(leaveDetail?.createdAt).format("DD/MM/YYYY")) ||
                      "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">From :-</span>
                    {(leaveDetail?.startDate &&
                      moment(leaveDetail?.startDate).format("DD/MM/YYYY")) ||
                      "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">To :-</span>
                    {(leaveDetail?.endDate &&
                      moment(leaveDetail?.endDate).format("DD/MM/YYYY")) ||
                      "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">Days :-</span>
                    {(leaveDetail?.startDate &&
                      moment(leaveDetail?.endDate).diff(
                        moment(leaveDetail?.startDate),
                        "days"
                      ) + 1) ||
                      "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      Leave Type :-
                    </span>
                    {leaveDetail?.leaveType || "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      Leave Reason :-
                    </span>
                    {leaveDetail?.reason || "--"}
                  </p>
                </li>

                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      Site Type :-
                    </span>
                    {uniqueSiteTypes.join(", ")}
                  </p>
                </li>

                {((checkUserAccess(userDetails).isUserAccess &&
                  location?.state?.type === "request") ||
                  location?.state?.type === "teamLeaveRequest") &&
                  leaveDetail?.status == 0 && (
                    <li className="col-12 col-md-6 col-lg-6">
                      <p>
                        <span className="d-flex align-items-center gap-3 justify-content-end">
                          <>
                            <button
                              className="btn btn-success"
                              onClick={() => HandleApprove_Reject("approve")}
                            >
                              Approve
                            </button>
                            <button
                              className="btn btn-danger"
                              onClick={() => toggleReject()}
                            >
                              Reject
                            </button>
                          </>
                        </span>
                      </p>
                    </li>
                  )}
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-12 ">
              <div className="card manage-user-list">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between border-bottom mb-3">
                    <h4 className="d-flex align-items-center mb-4">
                      Documents
                    </h4>
                  </div>
                  <ul className="row list-unstyled gap-3">
                    {leaveDetail?.documents?.length > 0 ? (
                      leaveDetail?.documents?.map((doc, index) => {
                        return (
                          <li className="col-12">
                            <div
                          className="text-muted fs-5 d-flex align-items-center justify-content-between text-decoration-none w-100"
                          onClick={() => handleDocumentClick(doc)}
                          role="button"
                        >
                          <span className="d-flex align-items-center gap-2">
                            <DocumentIcon />
                            {doc?.name || "Document"}
                          </span>
                          <span className="fs-6">
                            {doc?.updatedAt ? moment(doc?.updatedAt).format("DD MMM YYYY | h:mm a") : ""}
                          </span>
                        </div>
                          </li>
                        );
                      })
                    ) : (
                      <div>No Document Found</div>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Logs
          type={"leave"}
          id={id}
          refreshLogs={refreshLogs}
          setRefreshLogs={setRefreshLogs}
        />
      </>
      <ViewDocumentModal
        modal={modal}
        toggle={toggleModal}
        selectedDocument={selectedDocument}
      />
      <ConfirmModal
        modal={rejectLeaveModal}
        toggle={() => toggleReject()}
        submitHandler={HandleDelete}
        isLoading={isLoading}
        Reason={"reason"}
      />
    </>
  );
}
